'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Toggle = function (_Component) {
    _inherits(Toggle, _Component);

    function Toggle() {
        _classCallCheck(this, Toggle);

        var _this = _possibleConstructorReturn(this, (Toggle.__proto__ || Object.getPrototypeOf(Toggle)).apply(this, arguments));

        _this.state = {
            checked: false
        };
        _this.handleChange = function (event) {
            var _this$props = _this.props,
                onChange = _this$props.onChange,
                value = _this$props.value;
            var target = event.target;

            _this.setState({ checked: target.checked });
            if (onChange) {
                onChange(target.checked, value);
            }
        };
        return _this;
    }

    _createClass(Toggle, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                checkedValues = _props.checkedValues,
                value = _props.value,
                isChecked = _props.isChecked;

            this.setState({
                checked: checkedValues ? (0, _utils.includes)(checkedValues, value) : Boolean(isChecked)
            });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.checkedValues != null) {
                var checked = (0, _utils.includes)(nextProps.checkedValues, nextProps.value);
                this.setState({ checked: checked });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                className = _props2.className,
                label = _props2.label,
                disabled = _props2.disabled,
                value = _props2.value,
                _props2$id = _props2.id,
                id = _props2$id === undefined ? (0, _utils.idGen)('toggle') : _props2$id,
                inputClassName = _props2.inputClassName,
                labelClassName = _props2.labelClassName,
                name = _props2.name;
            var checked = this.state.checked;

            return _react2.default.createElement("div", { className: (0, _classnames2.default)('luna-toggle', className) }, _react2.default.createElement("input", { id: id, value: value && (0, _utils.stringify)(value), className: (0, _classnames2.default)('luna-toggle__input', inputClassName), type: "checkbox", name: name, disabled: disabled, checked: checked, onChange: this.handleChange }), _react2.default.createElement("label", { className: "luna-label luna-toggle__label", htmlFor: id }), _react2.default.createElement("span", { className: (0, _classnames2.default)('luna-toggle__text', labelClassName) }, label));
        }
    }]);

    return Toggle;
}(_react.Component);

exports.default = Toggle;

Toggle.propTypes = {
    isChecked: _propTypes2.default.bool.isRequired,
    className: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.node.isRequired,
    name: _propTypes2.default.string.isRequired,
    id: _propTypes2.default.string.isRequired,
    value: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string, _propTypes2.default.array, _propTypes2.default.number, _propTypes2.default.object]).isRequired,
    onChange: _propTypes2.default.func.isRequired,
    disabled: _propTypes2.default.bool.isRequired,
    inputClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired,
    labelClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired,
    checkedValues: _propTypes2.default.string.isRequired
};
//# sourceMappingURL=Toggle.js.map